import { APIURL } from '../constant/apiConstant'
import ApiService from './apiRequest'
import {Encryption as encrypt} from '../utilities/Encryption';
import AsyncStorageFunc from '../utilities/asyncStorage'
import {jwtDecode} from "jwt-decode"

  export const getDigiLockerStatus = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_DIGI_LOCKER_STATUS, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  }
  export const panValidationV2 = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.get(APIURL.GET_ENC_KEY)
        .then(async res => {
          const encryptedPan = await encrypt(params.panNumber, res.data);
          const encrypteddob = await encrypt(params.dob, res.data);
          const encryptedfullName = await encrypt(params.fullName, res.data);
  
          let formData = { panNumber: encryptedPan,dob : encrypteddob,fullName : encryptedfullName}
          if(params?.mobileNo !== "") {
            formData["mobileNo"] = params?.mobileNo
          }
          ApiService.postwithtoken(APIURL.PAN_VALIDATION,  formData )
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const initiateVerification = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.INITIATE_VERIFICATION, params)
        .then(res => {
          resolve(res);
        }).catch(err => { reject(err); });
    });
  }
  export const digilockerConfig = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.DIGILOCKER_CONFIG, params)
        .then(res => {
          resolve(res);
        }).catch(err => {reject(err); });
    });
  }
  export const getFuelKycStatus = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.GET_FUEL_KYC_STATUS)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const getFuelOtp = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.getWithToken(APIURL.FUEL_SEND_OTP)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  export const validateFuelOtp = (params) => {
    return new Promise((resolve, reject) => {
      ApiService.postwithtoken(APIURL.FUEL_VALIDATE_OTP, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
export const getFuelTransHistory = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  let token = await AsyncStorageFunc.getData('TOKEN');
  var decoded = jwtDecode(token);
  const header = {
    Authorization: "bearer " + token,
    deviceModel: "",
    appVersion: "",
    platform: "",
    network: "",
    deviceId: deviceId,
    userId: decoded.userCd,
    pageNo : params
  }
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.FUEL_TRANSACTION_HISTORY,{},header)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
  

 
  